import { fixedHeader } from "../fixedHeader";
import { initNavigation } from "../navigation";
import { initDesktopHeaderSearch } from "../search";
import { initHamburgerMenu } from "../hamburger";
import { initHamburgerAccordion } from "../hamburger";
import { initCookiesConsent } from "../cookies-consent";
import { initFormValidator } from "../form/form-validator";
import { initPopup } from "../../utils-shared/popup.js";

window.addEventListener("load", function () {
  fixedHeader();
  initNavigation();
  initDesktopHeaderSearch();
  initHamburgerMenu();
  initHamburgerAccordion();
  initCookiesConsent();
  initPopup();
  initFormValidator();
});
